import { useProductVariantDetailContext } from '.';
import { ProductType } from '../../types';

export const useSelectedVariants = () => {
    const { productVariantDetails, selectedProductSetVariants } = useProductVariantDetailContext();

    if (productVariantDetails?.type === ProductType.PRODUCT_SET) {
        return selectedProductSetVariants
            ? Object.values(selectedProductSetVariants).reduce<string[]>((acc, variant) => {
                  if (variant?.id) acc.push(variant.id);
                  return acc;
              }, [])
            : [];
    }

    return [productVariantDetails.sku];
};
